<template>
    <div id="app">
        <select-image />
        <select-house />
        <select-purchaser />
        <select-user />
        <select-store />
        <div class="yb-page">
            <div class="yb-header" v-if="!preview">
                <div class="logo" @click="$router.push('/')">
                    <!-- <img src="http://www.yibaicdn.com/d1c23f90-8b25-11e9-a215-4bc0baf4a45a.png">
                    <div>盛虹科技</div> -->
                </div>
                <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item v-for="(item, index) in paths" :key="index">{{item}}</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="flex-auto"></div>
                <el-dropdown class="setting" @command="handleCommand">
                    <i class="el-icon-setting el-dropdown-link"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="logout">退出登录<span v-if="loginState && loginState.admin">
                                ({{loginState.admin.description}})</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="yb-content">
                <div class="menu-container" v-if="!preview">
                    <el-scrollbar class="page-component__scroll">
                        <div class="header-auto" v-if="!preview"></div>
                        <left-menu />
                    </el-scrollbar>
                </div>
                <div class="router-view">
                    <el-scrollbar class="page-component__scroll baba" ref="myScrollbar">
                        <el-backtop target=".baba .el-scrollbar__wrap"></el-backtop>
                        <div class="header-auto" v-if="!preview"></div>
                        <router-view />
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { menus } from "./util/menu.js";
import LeftMenu from "./components/LeftMenu";
import { loginState } from "./util/login";
import SelectImage from "./components/select/SelectImage";
import SelectHouse from "./components/select/SelectHouse";
import SelectPurchaser from "./components/select/SelectPurchaser";
import SelectUser from "./components/select/SelectUser.vue";
import SelectStore from "./components/select/SelectStore.vue";

export default {
    name: "app",
    components: {
        LeftMenu,
        SelectImage,
        SelectPurchaser,
        SelectHouse,
        SelectUser,
        SelectStore,
    },
    data() {
        return {
            position: "",
            menus,
            loginState,
            menuTxt1: "首页",
            menuTxt2: "首页",
            preview: false,
            paths: [],
        };
    },
    created() {
        loginState.fetchAdminIfLogin();
        this.fetchData();
    },
    watch: {
        $route(to, from) {
            this.calcPath(to);
        },
    },
    computed: {},
    methods: {
        toTop() {
            this.$refs.myScrollbar.wrap.scrollTop = 0;
        },
        toBottom() {
            this.$refs.myScrollbar.wrap.scrollTop = 99999999;
        },
        async fetchData() {
            this.menus = loginState.getUserMenus();
            this.calcPath({
                path: this.$route.path,
            });
        },
        calcPath(to) {
            if (to.path.includes("preview")) {
                this.preview = true;
            } else if (to.path == "/") {
                this.paths = [];
            } else {
                for (let i = 0; i < this.menus.length; i++) {
                    const parent = this.menus[i];
                    for (let j = 0; j < parent.submenus.length; j++) {
                        const child = parent.submenus[j];
                        if (
                            this.$route &&
                            this.$route.path &&
                            child.path == this.$route.path
                        ) {
                            this.paths = [parent.text, child.text];
                        }
                    }
                }
            }
        },
        handleCommand(command) {
            if (command == "logout") {
                loginState.logout();
            }
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            return "padding:2px 0";
        },
        headerCelltyle({ row, column, rowIndex, columnIndex }) {
            return "padding:2px 0";
        },
    },
};
</script>

<style scoped lang="less">
#app {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
        "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

/deep/.el-submenu__title {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    padding-right: 0 !important;
}

/deep/.el-menu-item {
    height: 36px !important;
    line-height: 36px !important;
    font-size: 14px;
    padding-right: 0 !important;
    min-width: 0 !important;
}

.header-auto {
    height: 40px;
}

.page-component__scroll {
    height: 100%;
}

.page-component__scroll .el-scrollbar__wrap {
    overflow: auto;
}

.el-icon-setting {
    cursor: pointer;
    font-size: 20px;
    margin-right: 5px;
}

.yb-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .yb-header {
        background-image: radial-gradient(transparent 1px, #ffffff 1px);
        background-size: 4px 4px;
        backdrop-filter: saturate(50%) blur(4px);
        z-index: 2;
        box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.03);
        width: 100%;
        height: 40px;
        flex: none;
        // background-color: white;
        color: #999999;
        display: flex;
        align-items: center;
        font-size: 18px;
        position: absolute;
        top: 0;
        left: 0;
        .logo {
            width: 180px;
            height: 100%;
            background: #409eff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .txt {
                color: white;
                font-size: 14px;
                font-weight: bold;
            }
        }
        .setting {
            font-size: 16px;
            color: #606266;
            margin-right: 20px;
            span {
                cursor: pointer;
            }
        }
    }
    .yb-content {
        width: 100%;
        height: 0;
        flex: auto;
        display: flex;
        overflow: hidden;
        .menu-container {
            width: 180px;
            height: 100%;
            z-index: 1;
            box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.03);
            flex: none;
            overflow: hidden;
            box-sizing: border-box;
        }
        .router-view {
            padding: 0;
            background: white;
            flex: auto;
            height: 100%;
            position: relative;
            overflow: hidden;
            .yb-container {
                padding: 20px 32px;
                background: white;
            }
        }
    }
}
.el-icon--right {
    font-size: 14px;
    color: #909399;
}
</style>
